module.exports = __webpack_public_path__ + "static/media/frc-summer-2022-image-3.ece35f1f.png";